import { AxiosResponse } from "axios";
import ApiConstants from "../../../../../core/constants/api_constants";
import { request } from "../../../../../core/network/axiosInstance";


export class UserApiService {
    private readonly userBaseUrl: string;

    constructor() {
        this.userBaseUrl = ApiConstants().user;
    }

    async modifyProfile(formData: FormData): Promise<AxiosResponse> {
        const response = await request({
            method: "PATCH",
            url: `${this.userBaseUrl}`,
            data: formData,
            requiresToken: true,
        });
        return response
    }
} 